import React from 'react'
import CompSiteNav from './CompSiteNav'

const NotFound = () => {
  return (
    <>
      {/* <CompSiteNav /> */}

      <main className="grid min-h-full place-items-center py-80">
        <div className="text-center">
          <p className="text-base font-semibold text-xl  text-sky-600">404</p>
          <h1 className="mt-4 text-3xl font tracking-tight text-gray-100 sm:text-5xl">Page Not Found</h1>
          <p className="mt-6 text-base leading-7 text-gray-200">The resource you are requesting has moved or no longer exists</p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/"
              className="rounded-md bg-sky-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
            >
              Go back home
            </a>
          </div>
        </div>
      </main>
    </>
  )
}

export default NotFound